// components/AddSpaceModal/AddSpaceModalContent.jsx
import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import { FormButton } from "reusableComponents";
import { useTranslation } from "react-i18next";

const AddSpaceToGroupModal = ({ spaces, onConfirm, onClose }) => {
  // Initialize state with spaces already in group CHECKED
  const { t } = useTranslation("global");
  const [selectedSpaces, setSelectedSpaces] = useState(
    spaces.filter((space) => space.isInGroup).map((space) => space.id)
  );

  const toggleSpaceSelection = (spaceId) => {
    setSelectedSpaces((prev) =>
      prev.includes(spaceId)
        ? prev.filter((id) => id !== spaceId)
        : [...prev, spaceId]
    );
  };

  const handleSubmit = () => {
    onConfirm(selectedSpaces);
    onClose();
  };

  return (
    <div className={styles.modalContentWrapper}>
      <main className={styles.modalBody}>
        <div className={styles.spacesList}>
          {spaces.map((space) => (
            <div
              key={space.id}
              className={`${styles.space} ${
                selectedSpaces.includes(space.id) ? styles.spaceSelected : ""
              }`}
            >
              <div className={styles.spacePictureWrapper}>
                <div
                  className={styles.spacePicture}
                  style={{
                    backgroundImage: space.images?.length
                      ? `url(${space.images[0].image_url})`
                      : "none",
                  }}
                />
              </div>

              <div className={styles.spaceContent}>
                <div className={styles.spaceName}>
                  <h4>{space.name}</h4>
                  <span className={styles.spaceStatus}>
                    {space.isInGroup
                      ? space?.placeGroup.label
                      : t("dashboard.spacesManagement.noCategory")}
                  </span>
                </div>
                <div className={styles.spaceAddress}>
                  <span>{space.address?.address}</span>
                  <span>{space.address?.city}</span>
                </div>
              </div>

              <div className={styles.spaceCheckbox}>
                <input
                  type="checkbox"
                  checked={selectedSpaces.includes(space.id)}
                  onChange={() => toggleSpaceSelection(space.id)}
                />
              </div>
            </div>
          ))}
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.selectedCount}>
            Selected: {selectedSpaces.length} spaces
          </div>

          <FormButton
            label="Cancel"
            onClick={onClose}
            variant="gray"
            size="medium"
          />
          <FormButton
            label="Save Changes"
            onClick={handleSubmit}
            variant="primary"
            size="medium"
          />
        </div>
      </main>
    </div>
  );
};

export default AddSpaceToGroupModal;
